export function setLayoutOffset(isMobile: boolean, isMasquerading: boolean) : void {
    setMainContentWrapperOffset();
    setMainContentOffset(isMobile, isMasquerading);
}

/**
 * Apply header vertical offset to main content wrapper.
 *
 * Note: when the main menu is open on mobile-like viewports, it takes the full
 * height. In this scenario, the offset isn’t applied until the menu is closed.
 */
function setMainContentWrapperOffset(): void {
    const isMainMenuOpen = document.documentElement.classList.contains("mobile-navigation-open");
    const header = document.querySelector(".container--main-header") as HTMLElement;
    const mainContentWrapper = document.querySelector(".container-main-content") as HTMLElement;
    if (!mainContentWrapper) { return; }

    let headerOffsetY = 0;

    if (header && !isMainMenuOpen) {
        headerOffsetY = header.offsetHeight;
    }

    mainContentWrapper.style.marginTop = headerOffsetY + "px";
}

/**
 * Apply/reset wizard navigation vertical offset to main content.
 *
 * On mobile-like viewports, the wizard sidebar becomes a fixed top bar.
 * Its sibling main content must be offset by the wizard nav. height.
 */
function setMainContentOffset(isMobile: boolean, isMasquerading: boolean): void {
    const mainContent = document.getElementById("main-content") as HTMLElement;
    if (!mainContent) { return; }

    let wizardNavigationOffsetY = 0;

    if (isMobile && !isMasquerading) {
        const wizardNavigation = document.getElementById("main-sidebar");
        if (wizardNavigation) {
            wizardNavigationOffsetY = wizardNavigation.offsetHeight;
            mainContent.style.marginTop = wizardNavigationOffsetY + "px";
        }

    }
}

export function isNewPricePackLayoutEnabled(nowTs: number = Date.now()): boolean {
    const NEW_PRICE_PACK_LAYOUT_LOCAL_TS = new Date(2026, 0, 1, 0, 0, 0).getTime();
    
    return nowTs >= NEW_PRICE_PACK_LAYOUT_LOCAL_TS;
}
